// extracted by mini-css-extract-plugin
export var card = "_70-0";
export var expandedCard = "_70-2";
export var paginated = "_70-1";